<template>
  <div class="c-app flex-row align-items-center">
    <CContainer>
      <CRow class="justify-content-center">
        <CCol md="6">
          <CCardGroup>
            <CCard class="p-4">
              <CCardBody>
                <CForm>
                  <h1>Readfortheblind<span>Admin</span></h1>
                  <p class="text-muted">Sign In to your account</p>
                  <CInput
                    v-model="username"
                    placeholder="Username"
                    autocomplete="username email"
                  >
                    <template #prepend-content
                      ><CIcon name="cil-user"
                    /></template>
                  </CInput>
                  <CInput
                    v-model="password"
                    placeholder="Password"
                    type="password"
                    autocomplete="curent-password"
                  >
                    <template #prepend-content
                      ><CIcon name="cil-lock-locked"
                    /></template>
                  </CInput>

                  <CRow v-if="errorMessage" class="pb-3">
                    <CCol sm="12" class="text-danger text-center">
                      <span v-html="errorMessage"></span>
                    </CCol>
                  </CRow>

                  <CRow>
                    <CCol col="12" class="text-center">
                      <CButton
                        color="primary"
                        class="px-4"
                        @click="handleSubmit()"
                        >Login</CButton
                      >
                    </CCol>
                  </CRow>
                </CForm>
              </CCardBody>
            </CCard>
          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      errorMessage: ''
    }
  },
  methods: {
    handleSubmit() {
      if (!this.username) {
        this.errorMessage = 'กรุณากรอก Username'
        return
      }
      if (!this.password) {
        this.errorMessage = 'กรุณากรอก Password'
        return
      }

      this.$store
        .dispatch('login', {
          user: this.username,
          pass: this.password
        })
        .then(() => {})
        .catch((error) => {
          this.errorMessage = error
        })
    }
  }
}
</script>
<style scoped>
h1 span {
  font-weight: 200;
}
</style>
